"use strict";

require("./fill");

require("./padEnd");

require("./padStart");

require("./setPrototypeOf");

require("./textDecoder");

require("./textEncoder");